import { Program } from '~source/core/models/tv-guide';
import { isLiveProgram } from '~source/utils/is-live-program';

const isProgramReplay = (program: Program): boolean => {
    const now = new Date();
    const endDate = new Date(program.dateEnd);
    return endDate.getTime() < now.getTime();
};

const isProgramFuture = (program: Program): boolean => {
    const now = new Date();
    const startDate = new Date(program.dateStart);
    return startDate.getTime() > now.getTime();
};

export const buildEpgDeepLink = (program: Program): string => {
    if (isProgramFuture(program)) {
        return 'zst://follow-my-sports/';
    }

    const name = encodeURIComponent(program.title || '');
    const base = 'zst://epg';
    const params: string[] = [];
    params.push(`channelId=${encodeURIComponent(String(program.channelId))}`);

    if (!isLiveProgram(program) && isProgramReplay(program) && program.serial) {
        params.push(`serial=${encodeURIComponent(program.serial)}`);
    }

    params.push(`name=${name}`);

    if (typeof program.event === 'number') {
        params.push(`eventId=${encodeURIComponent(String(program.event))}`);
    }

    return `${base}?${params.join('&')}`;
};

export const navigateToEpgDeepLink = (program: Program): void => {
    const url = buildEpgDeepLink(program);
    window.location.href = url;
};
